/**
 * KAN-956/KAN-964: помощники раздела "Встречи и перезвоны".
 * Время шага в часовом поясе организации: сегодняшний ЧЧ:ММ, просроченный ДД.ММ ЧЧ:ММ.
 * Заголовок по выбранному дню, ключ месяца для календаря, сегодня в поясе организации.
 */
import { formatCrmRange, type MonthRef } from '@/lib/crmRange'
import { zonedParts } from '@/lib/orgTimezone'

export const TODAY_STEPS_TITLE = 'Встречи и перезвоны на сегодня'

export function formatStepTime(iso: string, timeZone: string, overdue: boolean): string {
  const date = new Date(iso)
  if (Number.isNaN(date.getTime())) return ''
  const time = new Intl.DateTimeFormat('ru-RU', { timeZone, hour: '2-digit', minute: '2-digit' }).format(date)
  if (!overdue) return time
  const day = new Intl.DateTimeFormat('ru-RU', { timeZone, day: '2-digit', month: '2-digit' }).format(date)
  return `${day} ${time}`
}

const pad = (n: number) => String(n).padStart(2, '0')

/** Сегодня ГГГГ-ММ-ДД в поясе (пока backend не прислал своё "today"). */
export function zonedToday(timeZone: string, now: Date = new Date()): string {
  const p = zonedParts(now, timeZone)
  return `${p.year}-${pad(p.month)}-${pad(p.day)}`
}

/** "ГГГГ-ММ" для запроса числа шагов по дням. */
export function monthKey(ref: MonthRef): string {
  return `${ref.year}-${pad(ref.month)}`
}

/** Заголовок: "... на сегодня" или "... на 5 ноября" (год, если не текущий). */
export function todayStepsTitle(day: string, today: string): string {
  if (day === today) return TODAY_STEPS_TITLE
  return `Встречи и перезвоны на ${formatCrmRange({ from: day, to: day }, today)}`
}
